import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { AuthSelectors, AuthService } from '../../auth/store/services';
import { LoadOfficeSettingsSuccess } from '../../auth/store/auth.actions';

@Component({
    selector: 'app-economic-settings',
    templateUrl: './economic-settings.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, FormsModule],
})
export class EconomicSettingsComponent {
    officeSettings$ = this.authSelectors.officeSettings$;
    token = '';
    saving = signal(false);
    error = signal('');

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private authSelectors: AuthSelectors,
        private authService: AuthService,
        private store: Store,
    ) {}

    onDismiss() {
        if (!this.saving()) this.ngbActiveModal.dismiss();
    }

    saveToken() {
        if (this.token.trim()) this.updateToken(this.token.trim());
    }

    removeToken() {
        this.updateToken(null);
    }

    private updateToken(value: string | null) {
        if (this.saving()) return;
        this.saving.set(true);
        this.error.set('');
        this.authService.updateSetting({ path: '/economicApiAgreementGrantToken', op: 'replace', value }).subscribe({
            next: settings => {
                this.store.dispatch(new LoadOfficeSettingsSuccess(settings));
                this.token = '';
                this.saving.set(false);
            },
            error: () => {
                this.saving.set(false);
                this.error.set(value === null
                    ? 'Token kunne ikke fjernes. Prøv igen.'
                    : 'Token kunne ikke gemmes. Prøv igen.');
            },
        });
    }
}
